import React, { useState, useRef, useEffect, useContext } from "react";
import CircularProgress from "@mui/material/CircularProgress";

import "./ImportVessel.scss";

import {
	Button,
	Table,
	COLORS,
	AttachmentsUpload,
	AbsCheckBox,
	Modal,
} from "abs-ui-components";

import axiosHttp from "../../services/interceptor";
import { importAdvantageVesselTemplateDownload, importVesselTemplateDownloadUrl } from "../../constants/import_constants";
import { emitToasterMsg } from "../../services/toasterUtility";
import xlsxImage from "../../images/excel-file-icon.svg";
import { FeatureType } from "../../constants/FeatureToggles";
import { ClaimsContext } from "../../services/ClaimsService";
const invalidFilesColumns = [
	{ Header: "File Name", accessor: "fileName" },
	{
		Header: "Message",
		accessor: "message",
		Cell: (row) => {
			return <span className="text-danger">{row.row.message}</span>;
		},
	},
];

const ImportVessel = (props) => {
	const [files, setFiles] = useState([]);
	const [invalidFiles, setInvalidFiles] = useState([]);
	const [invalidRows, setInvalidRows] = useState([]);
	const [validVesselData, setValidVesselData] = useState([]);
	const [uploadingVessel, setUploadingVessel] = useState(false);
	const [confirmingVessel, setConfirmingVessel] = useState(false);
	const fileInputRef = useRef(null); // Reference for file input element
	const [dragged, setDragged] = useState(null);
	const [validVesselsList, setValidVesselsList] = useState();
	const [checkedRows, setCheckedRows] = useState({});
	const [vesselConfirm, setVesselConfirm] = useState(false);
	const [prevCheckedRows, setPrevCheckedRows] = useState({});
    const {userHasFeature, userFeaturesAreLoaded} = useContext(ClaimsContext);
	const showOverwriteColumn = validVesselData.some(
		(row) => row.rowStatusId === 2
	);

	const vesselDatacolumns = [
		{ Header: "IMO Number", accessor: "imoNumber" },
		{ Header: "Vessel Name", accessor: "vesselName" },
		...(showOverwriteColumn
			? [
				{
					Header: "Overwrite",
					accessor: "",
					Cell: ({ row }) => {
						const rowId = row?.rowStatusId;
						let checkBoxId = `${row?.imoNumber}-${row.submitterWcnMstId}`;
						return rowId === 2 ? (
							<AbsCheckBox
								slim={true}
								id={checkBoxId}
								checked={checkedRows[checkBoxId] || false}
								handleChange={handleCheckboxChange(
									checkBoxId
								)}
							/>
						) : null;
					},
				},
			]
			: []),
	];

	useEffect(() => {
		cancelFileSelection();
	}, []);

	const handleCheckboxChange = (rowId) => (event) => {
		setCheckedRows((prev) => ({
			...prev,
			[rowId]: event.target.checked,
		}));
		if (event.target.checked) {
			setVesselConfirm(true);
		}
		setPrevCheckedRows({ ...checkedRows });
	};

	const handleCancelModal = () => {
		setCheckedRows(prevCheckedRows);
		setVesselConfirm(false);
	};

	const handleModalClose = () => {
		setVesselConfirm(false);
		setCheckedRows(prevCheckedRows);
	}

	useEffect(() => {}, [checkedRows]);

	const handleDownload = () => {
		const link = document.createElement("a");
		link.href = importVesselTemplateDownloadUrl;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};
     const handleAdvantageVesselTemplateDownload=()=>{
		const link = document.createElement("a");
		link.href = importAdvantageVesselTemplateDownload;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild();
	 }
	const handleRemoveFile = (index) => {
		cancelFileSelection();
		const newFiles = [...files];
		newFiles.splice(index, 1);
		setFiles(newFiles);
	};

	const fileSelectionHandler = (e) => {
		const newFiles = [...files];
		e?.forEach((selectedFile) => {
			newFiles.push(selectedFile.file);
		});
		setFiles(newFiles);
	};

	// Function to handle uploading the selected files
	const handleFileupload = () => {
		uploadFiles(files);
	};

	const uploadFiles = async (files) => {
		setUploadingVessel(true);
		const formData = new FormData();

		files.forEach((file) => {
			formData.append("importFiles", file);
		});
		axiosHttp
			.post(`api/MyFleet/ImportVessels`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then((response) => {
				if (response?.data) {
					const invalidFiles = response?.data?.filter(
						(e) => !e.isFileValid
					);
					if (invalidFiles.length > 0) {
						let invalidRows = [];
						response?.data?.forEach((file) => {
							const errorMessages = [];
							const firstResponse =
								file?.importVesselFileRowResponses?.[0];
							if (firstResponse?.rowStatusId === 0) {
								errorMessages.push(...firstResponse.errors);
							}
							if (errorMessages.length > 0) {
								invalidRows.push({
									fileName: file.fileName,
									message: errorMessages.map((msg, index) => (
										<div key={index}>
											{msg}
											<hr></hr>
										</div>
									)),
								});
								setInvalidRows(invalidRows);
							}
						});
					} else if (invalidFiles.length === 0) {
						setInvalidFiles([]);
						// else {
						setInvalidRows([]);
						let validData = [];
						response?.data?.forEach((file) => {
							file?.importVesselFileRowResponses?.forEach((e) => {
								validData.push({
									...e.vesselRequest,
									rowStatusId: e.rowStatusId,
								});
							});
						});
						setValidVesselsList(response?.data);
						setValidVesselData(validData);
						if (validData.length === 0) {
							emitToasterMsg(
								"error",
								"Import Vessels",
								"File does not have any data. Please add data to file and upload it again."
							);
						}
					} else {
						setInvalidFiles([]);
					}
				}
				setUploadingVessel(false);
			})
			.catch((error) => {
				console.error("Error from Upload API ::: ", error);
				setUploadingVessel(false);
			});
	};

	const saveVesselData = () => {

		setConfirmingVessel(true);
		const selectedVessels =
			validVesselsList[0]?.importVesselFileRowResponses?.filter(
				(response) => {
					const { imoNumber, submitterWcnMstId } =
						response.vesselRequest;
					const key = `${imoNumber}-${submitterWcnMstId}`;

					return checkedRows[key] || response.rowStatusId !== 2;
				}
			);
		if (selectedVessels.length === 0) {
			emitToasterMsg(
				"error",
				"Import Vessels",
				"No valid vessels selected."
			);
			setConfirmingVessel(false);
			return;
		}

		const selectedVesselsPayload = validVesselsList.map((item) => ({
			...item,
			importVesselFileRowResponses: selectedVessels,
		}));

		const payload = {
			importVesselFileResponses: selectedVesselsPayload,
		};

		axiosHttp
			.post(`api/MyFleet/ConfirmImportVessels`, payload)
			.then((response) => {
				if (response?.data?.data?.isSuccess) {
					emitToasterMsg(
						"success",
						"Import Vessels",
						"Imported successfully"
					);
					props.cancelImportVessel(true);
				} else {
					const errorMessages = response?.data?.data?.errorCode
						?.split("\n")
						?.filter((msg) => msg);
					emitToasterMsg("error", "Import Vessels", errorMessages);
				}
				setConfirmingVessel(false);
			})
			.catch((error) => {
				emitToasterMsg(
					"error",
					"Import Vessels",
					error?.response?.data?.errorMessage
				);
				setConfirmingVessel(false);
			});
	};

	// Function to cancel file selection and reset state
	const cancelFileSelection = () => {
		setFiles([]);
		setInvalidFiles([]);
		setInvalidRows([]);
		setValidVesselData([]);
		setCheckedRows({});
		setValidVesselsList([]);
		if (fileInputRef.current) {
			fileInputRef.current.value = "";
		}
	};

	const onDrag = (e) => {
		e.preventDefault();
		if (e.type === "dragover") {
			setDragged(true);
		}
		setDragged((prev) => {
			return prev;
		});
	};

	const onDrop = (e) => {
		e.preventDefault();
		if (e.type === "drop") {
			setDragged(false);
		}
		setDragged((prev) => {
			return prev;
		});
	};
	const onDraggingEnd = (e) => {
		setDragged(false);
	};

	var isAdvantageVesselTemplateEnabled = (userFeaturesAreLoaded && userHasFeature(FeatureType.AdvantageVesselTemplate));
	return (
		<div
			className="import-Vessel-wrapper"
			onDragLeave={(e) => onDraggingEnd(e)}
		>
			<div className="d-flex justify-content-center">
				<Button
					onClick={handleDownload}
					className="download-template-font"
				>
					Download Template
				</Button>
			</div>

			{isAdvantageVesselTemplateEnabled && (
				<div className="d-flex justify-content-center mt-2">
				<Button
				onClick={handleAdvantageVesselTemplateDownload}
					className="download-template-font"
				>
					Download Advantage Template
				</Button>
			</div>
			)}

			<div>
				<div className="selected-content-container mb-4">
					<div
						onDragOver={(e) => onDrag(e)}
						onDrop={(e) => onDrop(e)}
						className={
							dragged
								? "drag-drop-cls mt-4 ml-4 mr-4"
								: "mt-4 ml-4 mr-4"
						}
					>
						<AttachmentsUpload
							onFilesSelected={(e) => {
								fileSelectionHandler(e);
							}}
							supportedFormat="excel"
							supportedFileTypes="xlsx"
						/>

						<div className="selected-content mt-4">
							{files && files.length > 0 && (
								<>
									<div>Uploaded Files:</div>
									<div className="mt-3">
										{files.map((file, index) => (
											<div
												key={`import-vessel-${index}`}
												className="d-flex justify-content-between align-items-center px-3 py-1"
											>
												<div className="d-flex">
													<img
														src={xlsxImage}
														alt="Excel File Icon"
														className="xl-img mt-1"
													/>
													<span className="file-name p-2">
														{" "}
														{file?.name}{" "}
													</span>
												</div>
												<button
													type="button"
													className="close p-0"
													aria-label="Close"
													onClick={() =>
														handleRemoveFile(index)
													}
												>
													<span aria-hidden="true">
														{" "}
														×{" "}
													</span>
												</button>
											</div>
										))}
									</div>
									<div className="mt-4 d-flex upload-container">
										{uploadingVessel && (
											<CircularProgress size={30} />
										)}
										<Button
											primaryBackgroundColor={"#DC1E34"}
											primaryColor={"#DC1E34"}
											onClick={handleFileupload}
											className="ml-2"
											disabled={uploadingVessel}
										>
											Upload
										</Button>
										<Button
											onClick={cancelFileSelection}
											className="ml-2 select-file-color cancel-excel"
											primaryBackgroundColor={"#f9f9f9"}
											primaryColor={"#f9f9f9"}
										>
											Clear
										</Button>
									</div>
								</>
							)}
						</div>
						{invalidFiles.length > 0 && (
							<>
								<div className="mt-3">
									One or More errors found with files as below
									:
								</div>
								<Table
									columns={invalidFilesColumns}
									data={invalidFiles}
								/>
							</>
						)}

						{invalidRows.length > 0 && (
							<>
								<div className="mt-3">
									One or More errors found as below :
								</div>
								<Table
									columns={invalidFilesColumns}
									data={invalidRows}
								/>
							</>
						)}

						{validVesselData.length > 0 && (
							<>
								<div className="mt-3">
									Please verify the below data and click on
									submit :
								</div>
								<Table
									columns={vesselDatacolumns}
									data={validVesselData}
								/>
								<div className="float-right pb-4 d-flex">
									{confirmingVessel && (
										<CircularProgress size={30} />
									)}
									<Button
										primaryBackgroundColor={"#DC1E34"}
										primaryColor={"#DC1E34"}
										onClick={saveVesselData}
										className="ml-2"
										disabled={confirmingVessel}
									>
										Submit
									</Button>
								</div>
							</>
						)}
						<div>
							<Modal
								isOpen={vesselConfirm}
								modalHeader
								padding={"70px"}
								headerHeight={"50px"}
								showFooter
								onCloseClickListener={handleModalClose}
								footer={
									<div className="d-flex justify-content-end fixed-action-btns p-4">
										<Button
											className="modal-delete-btn fixed-button"
											onClick={() => {
												setVesselConfirm(false);
											}}
											primaryColor={COLORS.RED.DARK}
											primaryBackgroundColor={
												COLORS.RED.LIGHT
											}
										>
											Proceed
										</Button>
										<Button
											className="modal-cancel-btn"
											onClick={handleCancelModal}
										>
											Cancel
										</Button>
									</div>
								}
							>
								<div>
									Do you want to overwrite the existing vessel
									detail(s)?
								</div>
							</Modal>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ImportVessel;
